import HttpHelpers from './helpers';

const ContactUsApiEndpoints = {
  uploadMedia: (data) => {
    return HttpHelpers.unAuthenticatedAxios
      .post('contact-us/media', data)
      .then((response) => response.data);
  },
  contactUs: (data) => {
    return HttpHelpers.unAuthenticatedAxios
      .post('contact-us', data)
      .then((response) => response.data);
  },
};

export default ContactUsApiEndpoints;
